var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7,
    fill: "#D6D5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.0195C16.59 16.0195 16.25 15.6795 16.25 15.2695V11.9395C16.25 11.5295 16.59 11.1895 17 11.1895C17.41 11.1895 17.75 11.5295 17.75 11.9395V15.2695C17.75 15.6895 17.41 16.0195 17 16.0195Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0199 25.8502C14.4399 25.8502 11.8699 25.4402 9.41987 24.6202C8.50987 24.3202 7.81987 23.6702 7.51987 22.8502C7.21987 22.0302 7.31987 21.0902 7.80987 20.2702L9.07987 18.1502C9.35987 17.6802 9.60987 16.8002 9.60987 16.2502V14.1502C9.60987 10.0602 12.9299 6.74023 17.0199 6.74023C21.1099 6.74023 24.4299 10.0602 24.4299 14.1502V16.2502C24.4299 16.7902 24.6799 17.6802 24.9599 18.1502L26.2299 20.2702C26.6999 21.0502 26.7799 21.9802 26.4699 22.8302C26.1599 23.6802 25.4799 24.3302 24.6199 24.6202C22.1699 25.4502 19.5999 25.8502 17.0199 25.8502ZM17.0199 8.25023C13.7599 8.25023 11.1099 10.9002 11.1099 14.1602V16.2602C11.1099 17.0702 10.7899 18.2402 10.3699 18.9302L9.09987 21.0602C8.83987 21.4902 8.77987 21.9502 8.92987 22.3502C9.07987 22.7502 9.41987 23.0502 9.89987 23.2102C14.4999 24.7402 19.5599 24.7402 24.1599 23.2102C24.5899 23.0702 24.9199 22.7502 25.0699 22.3302C25.2299 21.9102 25.1799 21.4502 24.9499 21.0602L23.6799 18.9402C23.2599 18.2502 22.9399 17.0802 22.9399 16.2702V14.1702C22.9299 10.9002 20.2799 8.25023 17.0199 8.25023Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 28.4003C15.9299 28.4003 14.8799 27.9603 14.1199 27.2003C13.3599 26.4403 12.9199 25.3903 12.9199 24.3203H14.4199C14.4199 25.0003 14.6999 25.6603 15.1799 26.1403C15.6599 26.6203 16.3199 26.9003 16.9999 26.9003C18.4199 26.9003 19.5799 25.7403 19.5799 24.3203H21.0799C21.0799 26.5703 19.2499 28.4003 16.9999 28.4003Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.09b9fde20df56c0bf0f34ac44436a071.svg";
export { ForwardRef as ReactComponent };